// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2thKc","tabsBox":"styles_tabsBox__DUv2B","createButton":"styles_createButton__14MRf"};